import { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Inputs from './components/Inputs';
import { useTranslation } from 'react-i18next';
import GridProvider from './components/GridProvider';
import { urls } from './api/urls';
import useHttp from '../../../../../hooks/use-http';
import Spinner from '../../../../UI/Modal/Spinner';
import styles from './index.module.css';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../../shared/api/handleErrorMessage';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import DragAndDrop from '../../../../UI/DragAndDrop';
import { isFormValid } from './validation/isFormValid';

const INITIAL_VALUES = {
  id: 0,
  naziv: '',
  opis: '',
  partNumber: '',
  slikaB64: '',
  nabavnaCena: '',
  marza: null,
  marzaCount: '',
  prodajnaCena: '',
  favorit: false,
  akcija: false,
  nazivKategorije: '',
};

const Delovi = ({ machineId }) => {
  const {
    sendRequest: getDelovi,
    data: deloviData,
    isLoading: isLoadingDelovi,
    getData,
  } = useHttp('');

  const [formData, setFormData] = useState(INITIAL_VALUES);
  const [file, setFile] = useState([]);
  const [slika, setSlika] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [kategorijaDelova, setKategorijaDelova] = useState([]);

  const [expandedDetalis, setExpandedDetalis] = useState(true);
  const { t, i18n } = useTranslation();

  const vratiDeloveZaMasinu = () => {
    const config = {
      method: 'POST',
      url: urls.GET_DELOVI_ZA_ID,
      data: { id: machineId },
    };

    getDelovi(config);
  };
  const vratiKategorijuDelova = async () => {
    const config = {
      method: 'GET',
      url: urls.VRATI_KATEGORIJU_DELOVA,
    };
    const result = await getData(config);
    if (result) {
      setKategorijaDelova(result);
    }
  };

  useEffect(() => {
    vratiDeloveZaMasinu();
    vratiKategorijuDelova();
  }, []);

  const handleChangeSastavnice = () => {
    setExpandedDetalis(!expandedDetalis);
  };
  const handleNoviDeo = () => {
    setFormData(INITIAL_VALUES);
  };
  const getEditData = (item) => {
    setFormData(item);
  };
  const base64ToBlob = (base64, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const base64ToFile = (base64, filename, contentType) => {
    const blob = base64ToBlob(base64, contentType);
    const file = new File([blob], filename, { type: contentType });
    return file;
  };

  const vratiSlikuDela = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_SLIKE_ZA_DEO,
      data: { id: formData.id },
    };
    const response = await getData(config);
    setFormData((curr) => {
      return { ...curr, slikaB64: response };
    });
    if (response) {
      if (!response.includes('Nema')) {
        // const file = base64ToFile(response, 'png.png', 'image/png');
        const file = base64ToFile(response, formData.name, formData.type);
        const list = [file];
        setSlika(list);
      }
    }
  };
  useEffect(() => {
    if (formData.id > 0) {
      vratiSlikuDela();
    }
  }, [formData.id]);

  const handleOpenDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormData({ ...INITIAL_VALUES, id: id });
  };
  const handleFiles = (files) => {
    setFile(files);
  };
  const handleSlika = (file) => {
    setSlika(file);
  };
  const handleSaveForm = async () => {
    if (isFormValid(formData)) {
      return;
    }
    const fd = new FormData();
    fd.append('id', formData.id);
    fd.append('naziv', formData.naziv);
    fd.append('opis', formData.opis);
    fd.append('partNumber', formData.partNumber);
    fd.append('IdKorProm', +localStorage.idKorisnika);
    fd.append('nabavnaCena', +formData.nabavnaCena);
    if (formData.marza) {
      fd.append('marza', +formData.marza);
    }
    fd.append('prodajnaCena', +formData.prodajnaCena);
    if (formData.idKategorijeDela) {
      fd.append('idKategorijeDela', formData.idKategorijeDela);
    }
    fd.append('favorit', formData.favorit || false);
    fd.append('akcija', formData.akcija || false);
    fd.append('idMasine', +machineId);
    for (let i = 0; i < slika.length; i += 1) {
      fd.append('Slika', slika[0]);
    }

    const config = {
      method: 'POST',
      url: formData.id === 0 ? urls.INSERT_DELOVI : urls.UPDATE_DELOVI,
      data: fd,
    };
    const result = await getData(config);
    if (result?.id > 0) {
      handleNoviDeo();
      vratiDeloveZaMasinu();
      toast.success(t('dataAddedSuccessfully'));
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DELOVI,
      data: {
        id: formData.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      handleNoviDeo();
      vratiDeloveZaMasinu();
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleSaveFile = async () => {
    const fd = new FormData();
    fd.append('IdKorProm', +localStorage.idKorisnika);
    fd.append('idMasine', +machineId);
    if (file.length > 0) {
      fd.append('Fajl', file[0]);
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_EXCEL_DELOVI,
      data: fd,
    };
    const result = await getData(config);
    if (result?.rezultat === 1) {
      handleNoviDeo();
      setFile([]);
      vratiDeloveZaMasinu();
      toast.success(t('dataAddedSuccessfully'));
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  return (
    <div>
      {isLoadingDelovi ?? <Spinner />}
      <Accordion expanded={expandedDetalis} onChange={handleChangeSastavnice}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <strong>{t('addParts')}</strong>
        </AccordionSummary>
        <AccordionDetails>
          <div className={styles.accordionContainer}>
            <div className={styles.formContainer}>
              <Inputs
                formData={formData}
                setFormData={setFormData}
                handleSlika={handleSlika}
                slika={slika}
                kategorijaDelova={kategorijaDelova}
              />
              <div>
                <button
                  onClick={handleSaveForm}
                  className={styles.buttonSecondary}
                >
                  <i className={`fas fa-save ${styles.icon}`} />
                  {t('savePart')}
                </button>
                <button
                  onClick={handleNoviDeo}
                  className={styles.buttonSecondary}
                >
                  <i className={`fas fa-plus ${styles.icon}`} />
                  {t('newPart')}
                </button>
              </div>
            </div>
            <div
              style={{ borderLeft: '1px solid gray' }}
              className={styles.formContainer}
            >
              <DragAndDrop
                handleFiles={handleFiles}
                maxFiles={1}
                title="Učitavanje delova iz excela"
              />
              <div>
                {file.length > 0 && (
                  <button
                    onClick={handleSaveFile}
                    className={styles.buttonSecondary}
                    style={{ marginTop: '10px' }}
                  >
                    <i className={`fas fa-save ${styles.icon}`} />
                    {t('uploadFile')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <GridProvider
        data={deloviData}
        getEditData={getEditData}
        handleOpenDialog={handleOpenDialog}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Delovi;
